function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'dull-black': 'rgb(37, 37, 37)','gloss-black': 'rgb(0, 0, 0)','ash': 'rgb(217, 217, 217)','vintage-brown': 'rgb(154, 99, 36)','khaki': 'rgb(156, 140, 106)','smoked': 'rgb(0, 0, 0)','clear': 'rgb(255, 255, 255)','campaign': 'rgb(156, 0, 19)','gold-star': 'rgb(215, 145, 49)','stripe': 'rgb(20, 111, 226)','fast-as-fuck': 'rgb(215, 145, 49)','free-spirits': 'rgb(0, 0, 0)','matte-black': 'rgb(37, 37, 37)','matte-olive': 'rgb(143, 126, 94)','red-black': 'rgb(229, 1, 2)','mint-green': 'rgb(93, 223, 185)','baby-blue': 'rgb(50, 181, 211)','sunshine-yellow': 'rgb(244, 221, 28)','titanium-grey': 'rgb(133, 127, 122)',};

    this.images = {'2-pack': 'url("//steeltowngarage.com/cdn/shop/files/2-pack_120x.jpg?v=1290577709756847045")','3-pack': 'url("//steeltowngarage.com/cdn/shop/files/3-pack_120x.jpg?v=15009993493385428504")','buffalo-check': 'url("//steeltowngarage.com/cdn/shop/files/buffalocheck_120x.jpg?v=5185970007935674371")','classic': 'url("//steeltowngarage.com/cdn/shop/files/buffalocheck_120x.jpg?v=5185970007935674371")','checkered': 'url("//steeltowngarage.com/cdn/shop/files/buffalocheck_120x.jpg?v=5185970007935674371")','best-seller-pack': 'url("//steeltowngarage.com/cdn/shop/files/3-pack-socks-best_120x.jpg?v=14896082465560731135")','ss24-pack': 'url("//steeltowngarage.com/cdn/shop/files/3-pack-socks-ss24_120x.jpg?v=5851919412741625989")','black-white': 'url("//steeltowngarage.com/cdn/shop/files/buffalocheck_120x.jpg?v=5185970007935674371")','black-flake': 'url("//steeltowngarage.com/cdn/shop/files/blackflake_120x.jpg?v=9777910779932260104")','silver-flake': 'url("//steeltowngarage.com/cdn/shop/files/silverflake_120x.jpg?v=10334504468993450005")',};

    this.triggers = ['color','colour','couleur','farbe','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
